import { render } from "./ThePositionCloseConfirmDialog.vue?vue&type=template&id=5ce445bc&ts=true"
import script from "./ThePositionCloseConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ThePositionCloseConfirmDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__